import { FC } from 'react';
import { Case, Switch } from '@edikk-edikk/if';
import WhatsappSvg from '@edikk-edikk/country-layout-black-icon/src/messenger/whatsapp.svg';
import InstagramSvg from '@edikk-edikk/country-layout-black-icon/src/messenger/instagram.svg';
import TelegramSvg from '@edikk-edikk/country-layout-black-icon/src/messenger/telegram.svg';
import FanslySvg from '@edikk-edikk/country-layout-black-icon/src/messenger/fansly.svg';
import TwitchSvg from '@edikk-edikk/country-layout-black-icon/src/messenger/twitch.svg';
import OnlyFansSvg from '@edikk-edikk/country-layout-black-icon/src/messenger/only-fans.svg';
import XTwitterSvg from '@edikk-edikk/country-layout-black-icon/src/messenger/x-twitter.svg';
import SignalSvg from '@edikk-edikk/country-layout-black-icon/src/messenger/signal.svg';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { SocialLinkAlias } from './objects';

type PropsType = {
  alias: string;
};

const AdvertSocialLinkIcon: FC<PropsType> = ({
  alias,
}) => (
  <Switch>
    <Case condition={alias === SocialLinkAlias.whatsApp}>
      <SvgIcon Component={WhatsappSvg} width={25} height={25} />
    </Case>
    <Case condition={alias === SocialLinkAlias.instagram}>
      <SvgIcon Component={InstagramSvg} width={27} height={27} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.telegram}>
      <SvgIcon Component={TelegramSvg} width={20} height={17} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.twitch}>
      <SvgIcon Component={TwitchSvg} width={23} height={27} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.fansly}>
      <SvgIcon Component={FanslySvg} width={30} height={25} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.onlyFans}>
      <SvgIcon Component={OnlyFansSvg} width={27} height={27} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.xTwitter}>
      <SvgIcon Component={XTwitterSvg} width={23} height={23} isWithoutFill />
    </Case>
    <Case condition={alias === SocialLinkAlias.signal}>
      <SvgIcon Component={SignalSvg} width={27} height={27} isWithoutFill />
    </Case>
  </Switch>
);

export { AdvertSocialLinkIcon };
